export const ImageBackground = {
  transclude: true,

  bindings: {
    src: '<',
  },

  template: `
    <div class="image-background"
      ng-style="{ backgroundImage: $ctrl.backgroundImage }">
      <ng-transclude></ng-transclude>
    </div>`,

  controller($http, $filter, $scope) {
    'ngInject';

    return {
      $onChanges({ src }) {
        let hasChecked = false;

        if (!hasChecked && src.currentValue) {
          const backgroundImage = new Image();

          hasChecked = true;

          backgroundImage.onload = () => {
            $scope.$apply(() => {
              this.backgroundImage = `url("${backgroundImage.src}")`;
            });
          };

          backgroundImage.src = $filter('assetSrc')(src.currentValue);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Image/Background.js